export const PRIMARY_PHONE_NUMBER_FORMATTED = '13 39 38';
export const PRIMARY_PHONE_NUMBER_UNFORMATTED = '133938';
